import React, { useContext, useEffect, useState } from 'react';
import { FaIndianRupeeSign, FaStore } from 'react-icons/fa6';
import { MdEditDocument, MdOutlineRocketLaunch } from 'react-icons/md';
import { BsCreditCard2Front } from 'react-icons/bs';
import { TbFilePower, TbLoader2 } from 'react-icons/tb';
import { Link, useParams } from 'react-router';
import MembershipSeries from '../../Components/Membership/Configurations/MembershipSeries';
import TrulyUnlimitedCard from '../../Components/Membership/TypesOfCards/TrulyUnlimitedCard';
import ValueAdditionCard from '../../Components/Membership/TypesOfCards/ValueAdditionCard';
import { BASE_URL_API } from '../../References/URLs';
import ActiveStoreContext from '../../store/ActiveStoreContext';
import AuthContext from '../../store/auth-context';
import ConfigMembershipCNCCategoryAndServices from './ConfigMembershipCNCCategoryAndServices';
import ConfigMembershipCNCStoreAndServicesWrapper from './ConfigMembershipCNCStoreAndServicesWrapper';
import styles from './ConfigMembershipCreateNewCard.module.css';
import GeneralDetails from './GeneralDetails';
import { toast } from 'react-toastify';
import { IoQrCodeOutline } from 'react-icons/io5';

const ConfigMembershipCreateNewCard = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier

    const { membershipIdentifier, activeTab } = useParams()
    const [tabs, setTabs] = useState([
        {
            name: 'General',
            identifier: 'general-details',
            icon: <TbFilePower size={26} color="#a5a5a5" />
        },
        {
            name: 'Stores',
            identifier: 'stores',
            icon: <FaStore size={26} color="#a5a5a5" />
        },
        // {
        //     name: 'Services',
        //     identifier: 'services',
        //     icon: <FaStore size={26} color="#a5a5a5" />
        // },
        {
            name: 'Price And Validity',
            identifier: 'price-and-validity',
            icon: <FaIndianRupeeSign size={26} color="#a5a5a5" />
        },
        {
            name: 'Terms And Conditions',
            identifier: 'terms-and-conditions',
            icon: <MdEditDocument size={26} color="#a5a5a5" />
        },
        // {
        //     name: 'Preview & Launch',
        //     identifier: 'preview-and-launch',
        //     icon: <MdOutlineRocketLaunch size={26} color="#a5a5a5" />
        // },
        {
            name: 'Series',
            identifier: 'series',
            icon: <BsCreditCard2Front size={26} color="#a5a5a5" />
        }
    ])

    const [configurations, setConfigurations] = useState({
        cardType: '',
        isShareable: true,
        shareLimit: null,
        redeemableStores: [],
        validityDuration: '',
        termsAndConditions: ''
    })
    const [isUpdating, setIsUpdating] = useState(false)

    const configurationHandler = (f, v) => {
        setConfigurations({ ...configurations, [f]: v })
    }


    const [formValid, setFormValid] = useState(false);

    const getMembershipConfigurations = async () => {
        const response = await fetch(BASE_URL_API + "getMembershipConfigurations",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    membershipIdentifier: membershipIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setConfigurations(respo?.response)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(respo)
        }
    }

    useEffect(() => {
        getMembershipConfigurations()
    }, [])

    const updateConfiguration = async () => {
        if(window.confirm(`Are you sure to update the configuration details?`)) {
            setIsUpdating(true)
            console.log(configurations)
            const response = await fetch(BASE_URL_API + "updateMembershipConfigurations",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        authIdentifier: authCtx?.authIdentifier,
                        vendorIdentifier: vendorIdentifier,
                        storeIdentifier: activeStore?.storeIdentifier,
                        configurations: configurations,
                        membershipIdentifier: membershipIdentifier
                    })
                });
    
            if (!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo?.status === "success") {
                    toast(`Successfully updated the configurations details.`)
                } else {
                    if (respo?.message === "tokenExpired") {
                        authCtx?.logout()
                    }
                }
                console.log(respo)
            }
            setIsUpdating(false)
        }
    }

    const validThru = (() => { let d=new Date(); d.setDate(d.getDate()+ parseInt(configurations?.validityDuration) ); return `${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getFullYear()).slice(-2)}`; })();


    // console.log(activeTab, tabs)

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContentWrapper}>
                <div className={styles.leftColWrapper}>
                    <div className={styles.leftColContainer}>
                        {tabs?.map((item, index) => (
                            <div key={index} className={activeTab === item?.identifier ? styles.activeTabButton : styles.tabButton}>
                                <Link
                                    to={`/memberships/settings/${membershipIdentifier}/${item?.identifier}`}
                                    className={styles.eachIcon}
                                >
                                    <div>
                                        {item?.icon}
                                    </div>
                                    <div className={styles.optionTxt} >
                                        {item?.name}
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.rightColWrapper}>
                    <div className={styles.mainContainer} >
                        <div className={styles.formSection}>
                            {activeTab === "general-details" &&
                                <div className={styles.sectionContent}>
                                    <GeneralDetails configurations={configurations} configurationHandler={configurationHandler} />
                                    {/* <TrulyUnlimitedCard />
                                    <ValueAdditionCard /> */}
                                </div>
                            }

                            {/* Redeemable Stores */}
                            {activeTab === "stores" &&
                                <div className={styles.formGroup}>
                                    <ConfigMembershipCNCStoreAndServicesWrapper configurations={configurations} configurationHandler={configurationHandler} />
                                </div>
                            }

                            {/* Redeemable Services */}
                            {activeTab === "services" &&
                                <div className={styles.formGroup}>
                                    <ConfigMembershipCNCStoreAndServicesWrapper />
                                    <ConfigMembershipCNCCategoryAndServices />
                                </div>
                            }

                            {activeTab === "price-and-validity" &&
                                <div className={styles.priceAndValidityWrapper} >
                                    <div className={styles.priceWrapper}>
                                        <div className={styles.eachPrice} >
                                            <label>Membership Price</label>
                                            <input
                                                type="number"
                                                value={configurations?.membershipPrice}
                                                onChange={(e) => configurationHandler('membershipPrice', e.target.value)}
                                            />
                                        </div>
                                        {configurations?.cardTypeIdentifier === "VALUE_ADDITION" &&
                                            <div className={styles.eachPrice} >
                                                <label>Membership Worth Off</label>
                                                <input
                                                    type="number"
                                                    value={configurations?.membershipWorthOff}
                                                    onChange={(e) => configurationHandler('membershipWorthOff', e.target.value)}
                                                />
                                            </div>
                                        }
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label>Validity (Enter duration in days) </label>
                                        <input
                                            type="number"
                                            value={configurations?.validityDuration}
                                            onChange={(e) => configurationHandler('validityDuration', e.target.value)}
                                        />
                                    </div>
                                </div>
                            }

                            {/* Terms and Conditions */}
                            {activeTab === "terms-and-conditions" &&
                                <div className={styles.tncWrapper} >
                                    <div className={styles.formGroup}>
                                        <label>Terms and Conditions</label>
                                        <textarea
                                            rows="5"
                                            value={configurations?.tnc}
                                            onChange={(e) => configurationHandler('tnc', e.target.value)}
                                            placeholder="Write terms and conditions here..."
                                        />
                                    </div>
                                </div>
                            }

                            {/* Preview and Confirm */}
                            {activeTab === "preview-and-launch" &&
                                <div className={styles.actions}>
                                    okay
                                </div>
                            }

                            {activeTab === "series" &&
                                <div>
                                    <MembershipSeries />
                                </div>
                            }
                        </div>

                        {/* Preview Section */}
                        {activeTab !== 'series' &&
                            <div className={styles.previewSection}>
                                <div className={styles.previewSectionContainer}>
                                    <div>
                                        <div className={styles.cardPreview}>
                                            <div className={styles.cardTop}>
                                                <img src={activeStore?.invoiceLogo} alt="logo" className={styles.logo} />
                                                <span className={styles.cardType}>{configurations?.categoryTypeLabel?.split(" ")[0]}</span>
                                            </div>
                                            <div className={styles.cardMiddle}>
                                                <h3 className={styles.memberName}>{configurations?.name}</h3>
                                                <p className={styles.cardNumber}>8802 0452 7198 3043</p>
                                            </div>
                                            <div className={styles.cardBottom}>
                                                <div className={styles.validThru}>
                                                    <span>VALID THRU</span>
                                                    <strong> {validThru} </strong>
                                                </div>
                                                <IoQrCodeOutline className={styles.qrCode} size={15} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.footerActionWrapper}>
                                        {isUpdating === true ?
                                            <div className={styles.updateBtn} ><TbLoader2 size={18} className={styles.spinner} /> Updating...</div>
                                            :
                                            <div className={styles.updateBtn} onClick={() => updateConfiguration()} > Update</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfigMembershipCreateNewCard;


